import React, { useState, useRef, useEffect } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import GradeIcon from "@mui/icons-material/Grade";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import StarIcon from "@mui/icons-material/Star";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PeopleIcon from "@mui/icons-material/People";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useAppSelector } from "../hooks/store";
import { getRole } from "../reducers/authSlice";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import TurnedInIcon from '@mui/icons-material/TurnedIn';

import IosShareIcon from '@mui/icons-material/IosShare';
import {
  CLASS_SETTING,
  CLASS_TYPE2_NAME,
  STATUS_NAME,
  TEASER_VIDEO_STATUS,
} from "../constants/enums";

import { useDeleteClassByIdMutation } from "../service/class";
import { useSaveClassMutation } from "../service/content";
import { showError, showToast } from "../constants/toast";
import { useNavigate } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { MoreVertical, Heart, Share2, BookOpen, Flag } from "lucide-react";
import { REDIRECTLINK } from "../constants/url";
import { currencyMode, currencySymbol, selectCurrencyRates, selectCurrentCurrency } from "../reducers/currencySlice";
import { convertCurrency } from "../utils/currency";


export const RecommendedClasses = ({ data, saved }: any) => {
  const navigate = useNavigate();
  const [deleteClass] = useDeleteClassByIdMutation();
  const [saveClassApi, { isLoading }] = useSaveClassMutation();
  const roleName = useAppSelector(getRole);
  const isLong = data?.description && data.description.length > 50;
  const displayText = isLong
    ? data?.description?.slice(0, 50) + "..."
    : data?.description || "";
     const currencyRates = useAppSelector(selectCurrencyRates);
        const currentCurrency = useAppSelector(selectCurrentCurrency);
        const currentCurrencyMode = useAppSelector(currencyMode);
         const currentCurrencySymbol = useAppSelector(currencySymbol);



  const saveClassFunc = async () => {
    try {
      const body = { classId: data?._id };
      const res = await saveClassApi({ body }).unwrap();
      if (res?.statusCode == 200) {
        showToast("Class saved successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };

  const deleteClassFunc = async () => {
    try {
      const res = await deleteClass({ id: data?._id }).unwrap();
      if (res?.statusCode === 200) {
        showToast("Class deleted successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };

  // dropdown state
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="recm_card">
      <figure>
        <img
          onClick={() => {
            roleName == "parent"
              ? navigate(`/parent/ClassDetail/${data?._id}`)
              : navigate(`/tutor/classes/details/${data?._id}`);
          }}
          src={data?.thumbnail || `/static/images/recmd_classes.png`}
          alt="recmnd_classes"
        />
        <figcaption>
          {roleName == "parent" ? null : (
            <output className="icn_grp_del">
              {data?.classStatus == TEASER_VIDEO_STATUS.PENDING ? (
                <i onClick={() => navigate(`/tutor/create-class/${data?._id}`)}>
                  <BorderColorIcon />
                </i>
              ) : null}

              {data?.setting == CLASS_SETTING.DRAFT &&
                data?.classStatus == TEASER_VIDEO_STATUS.PENDING ? (
                <i onClick={deleteClassFunc} className="del">
                  <RestoreFromTrashIcon />
                </i>
              ) : null}
            </output>
          )}

          {data?.classStatus ? (
            <code
              className={`code ${data?.classStatus == TEASER_VIDEO_STATUS.APPROVED
                ? "approve"
                : data?.classStatus == TEASER_VIDEO_STATUS.REJECTED
                  ? "rejected"
                  : ""
                }`}
            >
              {STATUS_NAME[data?.classStatus]}
            </code>
          ) : null}

          <div className="btn_group recm_option_grp">
            <RWebShare
              data={{
                text: "Click on link to see the teaser video details",
                url: `${REDIRECTLINK}parent/ClassDetail/${data?._id}`,
                title: data?.topic || "",
              }}
            >
              <span><IosShareIcon /></span>
            </RWebShare>
            {roleName == "parent" ? (
              <span onClick={saveClassFunc} >{data?.isSave || saved ? < TurnedInIcon /> : < BookmarkBorderIcon />}</span>

            ) : null}



          </div>
        </figcaption>
      </figure>

      <div className="contnt__mn">
        <h4
          onClick={() => {
            roleName == "parent"
              ? navigate(`/parent/ClassDetail/${data?._id}`)
              : navigate(`/tutor/classes/details/${data?._id}`);
          }}
        >
          {data?.topic || "Online class"}
        </h4>

        <p
          onClick={() => {
            roleName == "parent"
              ? navigate(`/parent/ClassDetail/${data?._id}`)
              : navigate(`/tutor/classes/details/${data?._id}`);
          }}
          className="dess" dangerouslySetInnerHTML={{ __html: displayText || "" }} />

        <div
          onClick={() => {
            roleName == "parent"
              ? navigate(`/parent/ClassDetail/${data?._id}`)
              : navigate(`/tutor/classes/details/${data?._id}`);
          }}
          className="follow_cnt"
        >
          <div>
            {data?.tutor?.name ? (
              <h5>
                {data?.tutor?.name || ""}{" "}
                <span className="star">
                  <GradeIcon /> {data?.tutor?.avgRating || 0}
                </span>
              </h5>
            ) : null}
            {/* <p>
              {data?.subjects?.name ? data?.subjects?.name : ""}
              {data?.typeOfClass ? (
                <span className="block">
                  {CLASS_TYPE2_NAME[data?.typeOfClass] + " Class"}
                </span>
              ) : null}
              <span className="block">
                {data?.teachingDetail?.specialization
                  ? `Specialized in ${data?.teachingDetail?.specialization}`
                  : ""}
              </span>
            </p> */}

            <div className="class-info">
              <div className="info-item">
                <AccessTimeIcon fontSize="small" />
                <span>
                  {data?.duration ? `${(data.duration / 60).toFixed(1)} hrs` : "—"}
                </span>

              </div>
              {/* <div className="info-item">
                <PeopleIcon fontSize="small" />
                <span>12/15</span>
              </div>
              <div className="info-item">
                <CalendarTodayIcon fontSize="small" />
                <span>Mon, Wed</span>
              </div> */}
              <div className="info-item">
                <LocationOnIcon fontSize="small" />
                <span className="status online">{data?.user?.isActive ? "Online" : "Offline"}</span>
              </div>
            </div>
          </div>
          {/* {data?.tutor?.followers ? (
            <p className="folk">{data?.tutor?.followers || 0} Followers</p>
          ) : null} */}
        </div>

        <div className="card_footer">
          <div className="enroll_price">
            {`${currentCurrencySymbol} ${convertCurrency({
              price: data?.usdPrice
                ? data?.usdPrice:0,
              rate: currencyRates[currentCurrency],
            }).toLocaleString(`${currentCurrencyMode}`)}`
            }


            <span>/hr</span>
          </div>
          <button
            onClick={() => {
              roleName == "parent"
                ? navigate(`/parent/ClassDetail/${data?._id}`)
                : navigate(`/tutor/classes/details/${data?._id}`);
            }}
            className="btn primary enroll_btn"
          >
            Enroll Now
          </button>

          {/* Dropdown Menu */}
          <div className="saved_flx more-menu-wrapper" ref={menuRef}>
            <button
              className="more-btn"
              onClick={() => setOpen((prev) => !prev)}
            >
              <MoreVertical size={20} />
            </button>

            {open && (
              <div className="dropdown">
                <button className="dropdown-item" onClick={() => { saveClassFunc(); setOpen(false) }}>
                  <Heart size={18} /> Save Class
                </button>
                <RWebShare
                  data={{
                    text: "Click on link to see the teaser video details",
                    url: `${REDIRECTLINK}ClassDetail/${data?._id}`,
                    title: data?.topic || "",
                  }}
                >
                  <button className="dropdown-item">
                    <Share2 size={18} /> Share Class

                  </button>
                </RWebShare>
                <button onClick={() => {
                  roleName == "parent"
                    ? navigate(`/parent/ClassDetail/${data?._id}`)
                    : navigate(`/tutor/classes/details/${data?._id}`);
                }} className="dropdown-item">
                  <BookOpen size={18} /> View Curriculum
                </button>
                {/* <button className="dropdown-item danger">
                  <Flag size={18} /> Report Class
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
